











import Vue from 'vue';
import { Loader } from 'mycorems-app-shared';
import isGranted from '@/auth/isGranted';
import { Client } from '@/types';
import eventBus from '@/messaging/event-bus';
import { EmailReportGenerated, PricePlanStarted } from '@/messaging/events';
import repository from '../account/client/client-repository';
import ClientUsage from './ClientUsage.vue';

interface Data {
  task: Promise<Client>|null,
  client: Client|null,
}

export default Vue.extend({
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
      client: null,
    };
  },
  watch: {
    clientId: {
      handler(): void {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    hasActivePlan(): boolean {
      if (!this.client) return false;
      return (this.client.credits !== 0);
    },
    progress(): number {
      if (!this.client) return 0;
      return this.client.numGenerated / this.client.credits;
    },
  },
  methods: {
    onReportGenerated(): void {
      if (!this.client) return;
      this.load();
    },
    load(): void {
      this.task = repository.find(this.clientId);
      this.task.then((client: Client) => {
        this.client = client;
      });
    },
    isGranted,
  },
  created(): void {
    this.load();
    eventBus.$on(PricePlanStarted.eventName, this.load);
    eventBus.$on(EmailReportGenerated.eventName, this.onReportGenerated);
  },
  beforeDestroy(): void {
    eventBus.$off(PricePlanStarted.eventName, this.load);
    eventBus.$off(EmailReportGenerated.eventName, this.onReportGenerated);
  },
  components: {
    'client-usage': ClientUsage,
    loader: Loader,
  },
});
